const form = {
  formId: "oil-gas-01",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxId: {
      name: "taxId",
      label: "[04] Mã số thuế thức hiện kê khai nộp thuế",
      type: "text",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    orgName: {
      name: "orgName",
      label: "[05] Tên tổ chức chuyển nhượng",
      type: "text",
      errorMsg: "Vui lòng nhập",
    },
    taxId2: {
      name: "taxId2",
      label: "[06] Mã số thuế (nếu có)",
      type: "text",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    address: {
      name: "address",
      label: "[07] Địa chỉ trụ sở chính",
      type: "text",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    contract: {
      name: "contract",
      label: "[08] Hợp đồng dầu khí lô",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    contractNumber: {
      name: "contractNumber",
      label: "[09] Hợp đồng chuyển nhượng số",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    contractNumberDate: {
      name: "contractNumberDate",
      label: "Ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    orgName2: {
      name: "orgName2",
      label: "[10] Tên tổ chức hoặc cá nhân nhận chuyển nhượng",
      type: "text",
      errorMsg: "Vui lòng nhập",
    },
    address2: {
      name: "address2",
      label: "[11] Địa chỉ trụ sở chính",
      type: "text",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    taxId3: {
      name: "taxId3",
      label: "[12] Mã số thuế (đối với doanh nghiệp)",
      type: "text",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    taxId4: {
      name: "taxId4",
      label: "[13] Mã số thuế hoặc số chứng minh nhân dân, sổ hộ chiếu (đối với cá nhân)",
      type: "text",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    checkbox1: {
      name: "checkbox1",
      label: "[17] Tên đơn vị được ủy quyền",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "Hoặc đại lý thuế",
      type: "text",
    },
    taxId5: {
      name: "taxId5",
      label: "[15] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    orgName3: {
      name: "orgName3",
      label: "[23] Tên tổ chức bị chuyển nhượng tại Việt Nam",
      type: "text",
      errorMsg: "Vui lòng nhập",
    },
    taxId6: {
      name: "taxId6",
      label: "[24] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address3: {
      name: "address3",
      label: "[25] Địa chỉ trụ sở chính",
      type: "text",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    contract2: {
      name: "contract2",
      label: "[26] Hợp đồng dầu khí lô",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    moneyType: {
      name: "moneyType",
      label: "Đơn vị tiền",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
